export const DEFAULT_SUGGESTION = null

export default {
  suggestion: DEFAULT_SUGGESTION
}
